import { route } from "../../../../../../shim/jsbridge";

import { FIT_CONTENT_PROP } from "../../../../containers/report_summary/consts";
import styles from "./connectors.module.scss";

interface ConnectorsPromoProps {
  /** `/connectors/` is admin-gated, so only admins get the link; everyone else is pointed at them. */
  isAdmin: boolean;
}

/**
 * Replaces the whole Connectors card - header included - when no connector is configured on the
 * appliance. Standalone, so it carries its own box styling rather than relying on RLCard.
 */
const ConnectorsPromo = ({ isAdmin }: ConnectorsPromoProps) => (
  // A layout hook, not a test hook: it keeps the box at its own height instead of letting the grid
  // stretch it to a card-sized slot.
  <div
    className={styles.promo}
    {...FIT_CONTENT_PROP}
    data-testid="report_summary_connectors_promo"
  >
    Connect Spectra Analyze to your EDR — CrowdStrike Falcon, Microsoft
    Defender, SentinelOne, or Palo Alto Cortex XDR — or ServiceNow to correlate
    file intelligence across your security stack.{" "}
    {isAdmin ? (
      <>
        <a
          className={styles.promoLink}
          href={route("connectors_config_default")}
          data-testid="report_summary_connectors_configure_link"
        >
          Configure connectors
        </a>
        .
      </>
    ) : (
      "Contact your administrator for setup."
    )}
  </div>
);

export default ConnectorsPromo;
